import { Reducers } from '@sda/enums/store';
import { PublicNotificationMask } from '@sda/sdk/masks';
import { SDK } from './helpers/sdk';
import type { NotificationTypes } from '@sda/enums';
import type { FirestoreClientData } from './interfaces';
import type { Notification, NotificationMetadata } from '@sda/interfaces/notification';

/**
 * SDK Class to interact with Firestore Acts.
 */
export class Notifications extends SDK<Notification> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.NOTIFICATIONS);

    this.collection = this.fsh.Schema.PublicNotifications;

    this.PublicMap = PublicNotificationMask;
  }

  /**
   * Add a notification and schedule a delivery
   * @param  {string} to
   * @param  {string} eventType
   * @param  {any} metadata
   * @return {Promise<any>}
   */
  addNotification(
    to: string,
    eventType: NotificationTypes,
    metadata: NotificationMetadata = {},
  ): Promise<string> {
    const notification = {
      eventType,
      metadata,
      owner: to,
      processedDigest: false,
      collaborators: [
        to,
      ],
    };

    return this.create(this.filter(notification, this.PublicMap));
  }
}
